import { Entity, Type } from '@decahedron/entity';
import Picture from '@/entities/Picture';
import Formatter from '@/support/formatter';

export default class Part extends Entity {
  protected formatter = new Formatter();

  public id: string = null;

  public title: string = null;

  public description: string = null;

  public price: number = null;

  @Type(Picture) pictures: Picture[] = [];

  public isSold = false;

  public isReserved = false;

  public position: number = null;

  get priceString(): string {
    return `€ ${this.formatter.formatNumber(this.price)}`;
  }

  removePicture(picture: Picture) {
    for (let n = 0; n < this.pictures.length; n += 1) {
      if (this.pictures[n].url === picture.url) {
        this.pictures.splice(n, 1);
        break;
      }
    }
  }

  addPicture(picture: Picture) {
    if (!picture.position) {
      picture.position = this.pictures.length + 1; // eslint-disable-line
    }

    this.pictures.push(picture);
  }
}
